import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, isAuthenticated } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');

  // 이미 로그인된 상태라면 홈으로 리다이렉트
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    const success = await login(formData.email, formData.password);

    if (success) {
      // 로그인 성공 시 원래 가려던 페이지로 이동
      const from = (location.state as any)?.from || '/';
      navigate(from, { replace: true });
    } else {
      setError('이메일 또는 비밀번호가 올바르지 않습니다.');
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card fade-in">
          <div className="login-header">
            <h1 className="login-title">로그인</h1>
            <p className="login-subtitle">
              EasyAutoCall에 오신 것을 환영합니다
            </p>
          </div>

          <form className="login-form" onSubmit={handleSubmit}>
            {error && (
              <div style={{
                padding: '12px',
                marginBottom: '20px',
                backgroundColor: 'rgba(220, 53, 69, 0.1)',
                border: '1px solid var(--error-color)',
                borderRadius: '8px',
                color: 'var(--error-color)',
                fontSize: '14px'
              }}>
                {error}
              </div>
            )}

            <div className="form-group">
              <label className="form-label" htmlFor="email">
                이메일
              </label>
              <input
                id="email"
                name="email"
                type="email"
                className="form-input"
                placeholder="your@email.com"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="password">
                비밀번호
              </label>
              <input
                id="password"
                name="password"
                type="password"
                className="form-input"
                placeholder="비밀번호를 입력하세요"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-options">
              <label className="checkbox-label">
                <input type="checkbox" />
                <span>로그인 상태 유지</span>
              </label>
              <a href="/forgot-password" className="forgot-link">
                비밀번호 찾기
              </a>
            </div>

            <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%' }}>
              로그인
            </button>
          </form>

          <div className="login-divider">
            <span>또는</span>
          </div>

          <div className="login-footer">
            <p className="signup-text">
              계정이 없으신가요?{' '}
              <span className="signup-link-disabled">
                회원가입 (준비 중)
              </span>
            </p>
          </div>
        </div>

        <div className="login-info slide-in-right">
          <h2 className="info-title">
            배차 알림,<br />
            이제 자동으로
          </h2>
          <ul className="info-list">
            <li>
              <span className="info-icon">✓</span>
              <span>99.9% 발신 성공률</span>
            </li>
            <li>
              <span className="info-icon">✓</span>
              <span>콜당 30원 합리적인 요금</span>
            </li>
            <li>
              <span className="info-icon">✓</span>
              <span>실시간 발신 현황 모니터링</span>
            </li>
            <li>
              <span className="info-icon">✓</span>
              <span>24/7 무중단 서비스</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Login;
